import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setTitle_ac } from '../../actions/me.ac.js'

const NEW_REPORT_URL = 'https://ui.supercaredevops.com/workunits/openorders/main'

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 3
  },
  paper: {
    maxWidth: 640,
    margin: '0 auto',
    padding: theme.spacing.unit * 3
  },
  paragraph: {
    marginTop: theme.spacing.unit * 2
  }
})

// The Open Orders Tracking report has been decommissioned. This route is kept
// so old bookmarks and links land on an explanation instead of a blank page.
class OpenOrdersTrackingReportLanding extends React.Component {
  componentDidMount() {
    this.props.setTitle_ac('Open Orders Tracking Report')
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Typography variant="h5">
            This report is no longer available
          </Typography>
          <Typography variant="body1" className={classes.paragraph}>
            The Open Orders Tracking report has been retired and replaced by the
            new Open Orders report.
          </Typography>
          <Typography variant="body1" className={classes.paragraph}>
            Please use the new report here:{' '}
            <a href={NEW_REPORT_URL}>{NEW_REPORT_URL}</a>
          </Typography>
          <Typography variant="body1" className={classes.paragraph}>
            If you bookmarked this page, please update your bookmark to the new
            link.
          </Typography>
        </Paper>
      </div>
    )
  }
}

OpenOrdersTrackingReportLanding.propTypes = {
  classes: PropTypes.object.isRequired,
  setTitle_ac: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setTitle_ac }, dispatch)

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(OpenOrdersTrackingReportLanding))
